"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failure = void 0;
var Failure = /** @class */ (function (_super) {
    __extends(Failure, _super);
    function Failure() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Failure";
        _this.reason = function () {
            _this.push(function (_) { return "reason"; });
        };
        _this.failureType = function () {
            _this.push(function (_) { return "failureType"; });
        };
        _this.exitCode = function () {
            _this.push(function (_) { return "exitCode"; });
        };
        _this.affectedContainer = function () {
            _this.push(function (_) { return "affectedContainer"; });
        };
        _this.logs = function () {
            _this.push(function (_) { return "logs"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Failure;
}(Array));
exports.Failure = Failure;
//# sourceMappingURL=Failure.js.map